import { IRichTextInformation } from "@bond-london/graphcms-rich-text";
import classNames from "classnames";
import { GatsbyImage, IGatsbyImageData } from "gatsby-plugin-image";
import React, { useState } from "react";

import { RTF } from "../elements/RTF";
import { ArrowHeadIcon } from "../icons/ArrowHeadIcon";

interface Props {
  title?: string;
  image?: IGatsbyImageData;
  alt?: string;
  message?: IRichTextInformation;
}
export const AccordionRow: React.FC<Props> = (props) => {
  const { title, image, alt, message } = props;
  const [isCollapsed, setIsCollapsed] = useState(true);
  return (
    <>
      <button
        onClick={() => setIsCollapsed(!isCollapsed)}
        className={classNames(
          "flex",
          "items-center",
          "justify-end",
          "pt-30px",
          "pb-30px",
          "w-full",
        )}
      >
        {title && <h3 className="h4">{title}</h3>}
        <ArrowHeadIcon
          className={classNames(
            isCollapsed ? "" : "rotate-180 transform",
            "ml-30px",
          )}
        />
      </button>
      <div className={classNames(isCollapsed ? "h-0 overflow-hidden" : "")}>
        <div
          className={classNames(
            "pb-30px",
            "md:flex",
            "md:flex-row",
            "md:justify-between",
          )}
        >
          <div className={classNames("mb-30px", "md:w-5/12")}>
            {image && (
              <GatsbyImage
                image={image}
                alt={alt ?? title ?? "Image"}
                className={classNames(
                  "w-full",
                  "aspect-w-4",
                  "aspect-h-3",
                  "bg-gradient-to-t to-hyacinth",
                )}
              />
            )}
          </div>
          {message && (
            <div className={classNames("md:w-6/12")}>
              <RTF
                className="p4 flex flex-col justify-center"
                content={message}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};
